import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { SelectInput, useControlledValue } from '../../internal';
import { SelectMobileModal } from './SelectMobileModal';

/**
 * select-компонент для выбора одного значения из списка
 *
 * Только мобильный вариант, открывающий список в модальном окне
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var SelectMobile = /*#__PURE__*/React.forwardRef(function SelectMobile(props, forwardedRef) {
  var onClick = props.onClick,
    selectInputProps = _objectWithoutProperties(props, _excluded);
  var inputRef = React.useRef(null);
  var ref = useForkRef(forwardedRef, inputRef);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _useControlledValue = useControlledValue(props, null),
    value = _useControlledValue.value,
    onChange = _useControlledValue.onChange;
  var handleInputClick = React.useCallback(function (e) {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      setOpen(true);
    }
  }, [onClick]);
  var handleCloseModal = React.useCallback(function () {
    var input = inputRef.current;
    setOpen(false);
    if (input) {
      input.focus();
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectInput, _objectSpread(_objectSpread({}, selectInputProps), {}, {
      ref: ref,
      open: open,
      onClick: handleInputClick,
      role: "button",
      "aria-haspopup": "listbox",
      value: value
    })), /*#__PURE__*/_jsx(SelectMobileModal, {
      options: props.options,
      open: open,
      onClose: handleCloseModal,
      value: value,
      onChange: onChange,
      title: props.title || props.placeholder
    })]
  });
});